module.exports = __webpack_public_path__ + "static/media/upp_flo_lig.3ade5613.png";